import numeral from "numeral";

export default {
    pretty: function(value) {
        return JSON.stringify(value, null, 2);
    },
    currency: function(value) {
        return numeral(parseFloat(value)).format("0.00");
    }
};
